// The building user is the account a property's posts appear from
// (Building.PMCommenter). The building endpoints return it as an email.
export const isBuildingUserEmail = (
  email?: string | null,
  pmCommenterEmail?: string | null
): boolean =>
  !!email &&
  !!pmCommenterEmail &&
  email.trim().toLowerCase() === pmCommenterEmail.trim().toLowerCase();

export const BUILDING_USER_LABEL = 'Building user';

// Cobu navy, so it doesn't read as the green "HomeBody User" label.
export const BUILDING_USER_LABEL_STYLE = { backgroundColor: '#272163' };
